module.exports = __webpack_public_path__ + "resources/img/img_security_ahnlab_vaips.f0b23ec49891b423bc704116f788090b.png";